// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"folder-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2 20L22 20V9.75L2 9.75L2 20Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M9 3.5H2V9.75H22V6H11L9 3.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2 9.75V20H22V9.75M2 9.75H22M2 9.75V3.5H9L11 6H22V9.75","strokeWidth":"props.strokeWidth"}}]}]};

const Folder1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'folder-1',
    ref,
    icon: element,
  },
));

Folder1Icon.displayName = 'Folder1Icon';

export default Folder1Icon;
